import { multi, withDependencies, optional } from '@wix/thunderbolt-ioc'
import type {
	IRendererPropsExtender,
	ServiceProvider,
	Experiments } from '@wix/thunderbolt-symbols'
import {
	SiteServicesManagerSymbol,
	ServiceProviderSymbol,
	SignalsServiceProviderSymbol,
	ExperimentsSymbol,
} from '@wix/thunderbolt-symbols'
import { createServicesManager, createServicesMap } from '@wix/services-manager'
import { ServicesManagerProvider } from '@wix/services-manager-react'
import type { ServicesManager } from '@wix/services-manager/types'

export const SiteServiceManager = withDependencies<ServicesManager>(
	[
		multi(ServiceProviderSymbol),
		SignalsServiceProviderSymbol,
		ExperimentsSymbol,
	],
	(
		servicesProviders: Array<ServiceProvider>,
		signalsServiceProvider: ServiceProvider,
		experiments: Experiments,
	): ServicesManager => {
		const isServicesInfraOpen = !!experiments['specs.thunderbolt.servicesInfra']
		const services = [signalsServiceProvider]
		return createServicesManager(createServicesMap(isServicesInfraOpen ? [...servicesProviders, ...services] : []))
	}
)

export const ServiceRegistrarPropsExtender = withDependencies(
	[SiteServicesManagerSymbol],
	(servicesManager: ServicesManager): IRendererPropsExtender => {
		return {
			async extendRendererProps() {
				return { servicesManager, ServicesManagerProvider }
			},
		}
	}
)
